package org.dronda.app.web.ui

import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import app.cash.molecule.RecompositionMode
import app.cash.molecule.launchMolecule
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.StateFlow
import org.dronda.app.web.repository.UserRepository

class MainScreenViewModel(
    val userRepository: UserRepository,
) {
    private val scope = CoroutineScope(Dispatchers.Main)
    private val eventSink = MutableSharedFlow<Event>(extraBufferCapacity = 8)

    val state: StateFlow<UIState> = scope.launchMolecule(mode = RecompositionMode.Immediate) {
        val userState by userRepository.userState.collectAsState()
        UIState(
            isLoggedIn = userState is UserRepository.State.LoggedIn,
            loading = userState is UserRepository.State.Loading,
        )
    }

    sealed interface Event {}
    data class UIState(
        val loading: Boolean,
        val isLoggedIn: Boolean,
    )
}